<template>
  <header class="nm" :class="{ 'nm--scrolled': scrolled, 'nm--open': menuOpen }">
    <div class="nm__bar">
      <router-link to="/" class="nm__logo" aria-label="Assuraf">
        <img src="../assets/img/assuraf_sm.png" alt="Assuraf" />
      </router-link>

      <nav class="nm__nav" v-responsive.lg.xl>
        <div class="nm-dd" @mouseenter="openMenu('assurances')" @mouseleave="closeMenu('assurances')">
          <button type="button" class="nm__link" :class="{ 'is-active': activeMenu === 'assurances' }">
            {{ $t('menu.Assurances[0]') }}
            <i class="fas fa-chevron-down nm__caret"></i>
          </button>
          <transition name="nm-fade">
            <div class="nm-dd__panel nm-dd__panel--single" v-if="activeMenu === 'assurances'">
              <a
                v-for="item in assuranceItems"
                :key="'ass-' + item.label"
                :href="item.href"
                class="nm-dd__item"
              >
                <span class="nm-dd__chip" :class="'nm-dd__chip--' + item.tone">
                  <i :class="item.icon"></i>
                </span>
                <span class="nm-dd__meta">
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.desc }}</small>
                </span>
              </a>
            </div>
          </transition>
        </div>

        <router-link to="/apropos" class="nm__link">{{ $t('menu.A_propos[0]') }}</router-link>
        <router-link to="/ContactForm" class="nm__link">{{ $t('menu.Contact') }}</router-link>
      </nav>

      <div class="nm__right">
        <div class="nm__ctas" v-responsive.lg.xl>
          <div class="nm-dd" @mouseenter="openMenu('devis')" @mouseleave="closeMenu('devis')">
            <button
              type="button"
              class="nm__link nm__link--highlight"
              :class="{ 'is-active': activeMenu === 'devis' }"
            >
              <i class="fas fa-file-alt nm__link-ico"></i>
              {{ $t('menu.Devis[0]') }}
              <i class="fas fa-chevron-down nm__caret"></i>
            </button>
            <transition name="nm-fade">
              <div class="nm-dd__panel nm-dd__panel--devis" v-if="activeMenu === 'devis'">
                <p class="nm-dd__title">{{ $t('home_page.particulier_label') }}</p>
                <div class="nm-dd__grid">
                  <a
                    v-for="item in devisParticulier"
                    :key="'dp-' + item.label"
                    :href="item.href"
                    class="nm-dd__item"
                  >
                    <span class="nm-dd__chip" :class="'nm-dd__chip--' + item.tone">
                      <img :src="item.icon" :alt="item.label" />
                    </span>
                    <span class="nm-dd__meta">
                      <strong>{{ item.label }}</strong>
                      <small>{{ item.desc }}</small>
                    </span>
                  </a>
                </div>
                <div class="nm-dd__rule"></div>
                <p class="nm-dd__title">{{ $t('home_page.entreprise_label') }}</p>
                <div class="nm-dd__grid nm-dd__grid--4">
                  <a
                    v-for="item in devisEntreprise"
                    :key="'de-' + item.label"
                    :href="item.href"
                    class="nm-dd__item"
                  >
                    <span class="nm-dd__chip" :class="'nm-dd__chip--' + item.tone">
                      <img :src="item.icon" :alt="item.label" />
                    </span>
                    <span class="nm-dd__meta">
                      <strong>{{ item.label }}</strong>
                      <small>{{ item.desc }}</small>
                    </span>
                  </a>
                </div>
              </div>
            </transition>
          </div>

          <div class="nm-dd" @mouseenter="openMenu('simulation')" @mouseleave="closeMenu('simulation')">
            <button
              type="button"
              class="nm__link nm__link--highlight nm__link--blue"
              :class="{ 'is-active': activeMenu === 'simulation' }"
            >
              <i class="fas fa-bolt nm__link-ico"></i>
              {{ $t('home_page.bouton_simulation_view') }}
              <i class="fas fa-chevron-down nm__caret"></i>
            </button>
            <transition name="nm-fade">
              <div class="nm-dd__panel nm-dd__panel--single" v-if="activeMenu === 'simulation'">
                <a
                  v-for="item in simulationItems"
                  :key="'sim-' + item.label"
                  :href="item.href"
                  class="nm-dd__item"
                >
                  <span class="nm-dd__chip" :class="'nm-dd__chip--' + item.tone">
                    <img :src="item.icon" :alt="item.label" />
                  </span>
                  <span class="nm-dd__meta">
                    <strong>{{ item.label }}</strong>
                    <small>{{ item.desc }}</small>
                  </span>
                </a>
              </div>
            </transition>
          </div>
        </div>

        <a class="nm__phone" href="tel:+221761416464" aria-label="+221 76 141 64 64">
          <i class="fas fa-phone"></i>
        </a>

        <select
          aria-label="language_select"
          class="nm__lang"
          v-model="$i18n.locale"
          @change="updateLanguage"
        >
          <option value="FR">FR</option>
          <option value="EN">EN</option>
        </select>

        <div v-responsive.lg.xl class="nm__account">
          <template v-if="!isLoggedIn">
            <button type="button" class="nm__connect" @click="showLoginForm = true">
              {{ $t('home_page.nh_menu_connect') }}
            </button>
            <button type="button" class="nm__cta" @click="showLoginForm = true">
              {{ $t('home_page.nh_menu_cta') }}
            </button>
          </template>
          <template v-else>
            <div class="nm-user" @mouseenter="openMenu('account')" @mouseleave="closeMenu('account')">
              <button type="button" class="nm-user__avatar" :aria-label="username">
                <span>{{ initials }}</span>
              </button>
              <transition name="nm-fade">
                <div class="nm-user__menu" v-if="activeMenu === 'account'">
                  <router-link to="/dashboard" class="nm-user__item">
                    <i class="fas fa-user"></i>
                    {{ $t('menu.Login[0]') }}
                  </router-link>
                  <a href="javascript:void(0)" class="nm-user__item" @click="logout">
                    <i class="fas fa-sign-out-alt"></i>
                    {{ $t('menu.Login[1]') }}
                  </a>
                </div>
              </transition>
            </div>
          </template>
        </div>

        <button type="button" class="nm__burger" aria-label="Menu" @click="menuOpen = !menuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <transition name="nm-drawer">
      <div class="nm-drawer" v-if="menuOpen" v-responsive.sm.xs>
        <div class="nm-drawer__head">
          <router-link to="/" class="nm__logo" @click.native="menuOpen = false">
            <img src="../assets/img/assuraf_sm.png" alt="Assuraf" />
          </router-link>
          <button type="button" class="nm-drawer__close" aria-label="Fermer" @click="menuOpen = false">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="nm-drawer__body">
          <div class="nm-acc" :class="{ 'is-open': drawerOpen === 'devis' }">
            <button type="button" class="nm-acc__toggle nm-acc__toggle--highlight" @click="toggleDrawer('devis')">
              <span class="nm-acc__ttl"><i class="fas fa-file-alt"></i> {{ $t('menu.Devis[0]') }}</span>
              <i class="fas fa-chevron-down"></i>
            </button>
            <div class="nm-acc__panel">
              <p class="nm-acc__group">{{ $t('home_page.particulier_label') }}</p>
              <a
                v-for="item in devisParticulier"
                :key="'mdp-' + item.label"
                :href="item.href"
                class="nm-acc__item"
                @click="menuOpen = false"
              >
                <span class="nm-acc__chip" :class="'nm-acc__chip--' + item.tone">
                  <img :src="item.icon" :alt="item.label" />
                </span>
                <span class="nm-acc__meta">
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.desc }}</small>
                </span>
              </a>
              <p class="nm-acc__group">{{ $t('home_page.entreprise_label') }}</p>
              <a
                v-for="item in devisEntreprise"
                :key="'mde-' + item.label"
                :href="item.href"
                class="nm-acc__item"
                @click="menuOpen = false"
              >
                <span class="nm-acc__chip" :class="'nm-acc__chip--' + item.tone">
                  <img :src="item.icon" :alt="item.label" />
                </span>
                <span class="nm-acc__meta">
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.desc }}</small>
                </span>
              </a>
            </div>
          </div>

          <div class="nm-acc" :class="{ 'is-open': drawerOpen === 'simulation' }">
            <button type="button" class="nm-acc__toggle nm-acc__toggle--highlight nm-acc__toggle--blue" @click="toggleDrawer('simulation')">
              <span class="nm-acc__ttl"><i class="fas fa-bolt"></i> {{ $t('home_page.bouton_simulation_view') }}</span>
              <i class="fas fa-chevron-down"></i>
            </button>
            <div class="nm-acc__panel">
              <a
                v-for="item in simulationItems"
                :key="'msim-' + item.label"
                :href="item.href"
                class="nm-acc__item"
                @click="menuOpen = false"
              >
                <span class="nm-acc__chip" :class="'nm-acc__chip--' + item.tone">
                  <img :src="item.icon" :alt="item.label" />
                </span>
                <span class="nm-acc__meta">
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.desc }}</small>
                </span>
              </a>
            </div>
          </div>

          <div class="nm-acc" :class="{ 'is-open': drawerOpen === 'assurances' }">
            <button type="button" class="nm-acc__toggle" @click="toggleDrawer('assurances')">
              {{ $t('menu.Assurances[0]') }}
              <i class="fas fa-chevron-down"></i>
            </button>
            <div class="nm-acc__panel">
              <a
                v-for="item in assuranceItems"
                :key="'mass-' + item.label"
                :href="item.href"
                class="nm-acc__item"
                @click="menuOpen = false"
              >
                <span class="nm-acc__chip" :class="'nm-acc__chip--' + item.tone">
                  <i :class="item.icon"></i>
                </span>
                <span class="nm-acc__meta">
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.desc }}</small>
                </span>
              </a>
            </div>
          </div>

          <router-link to="/apropos" class="nm-acc__link" @click.native="menuOpen = false">
            {{ $t('menu.A_propos[0]') }}
          </router-link>
          <router-link to="/ContactForm" class="nm-acc__link" @click.native="menuOpen = false">
            {{ $t('menu.Contact') }}
          </router-link>
          <a href="javascript:void(0)" class="nm-acc__link" @click="goToSinistre">
            {{ $t('menu.sinistre_label') }}
          </a>
        </div>

        <div class="nm-drawer__foot">
          <button
            type="button"
            class="nm-drawer__cta"
            v-if="!isLoggedIn"
            @click="showLoginForm = true; menuOpen = false"
          >
            {{ $t('home_page.nh_menu_cta') }}
          </button>
          <template v-else>
            <router-link to="/dashboard" class="nm-drawer__cta" @click.native="menuOpen = false">
              {{ $t('menu.Login[0]') }}
            </router-link>
            <button type="button" class="nm-drawer__cta nm-drawer__cta--ghost" @click="logout">
              {{ $t('menu.Login[1]') }}
            </button>
          </template>
        </div>
      </div>
    </transition>

    <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
  </header>
</template>

<script>
import Api from '../services/Api';
import store from '../store/store';

export default {
  name: 'NewMenu',
  components: {
    LoginForm: () => import(/* webpackPrefetch: true */ './auth/Login')
  },
  data: () => ({
    scrolled: false,
    menuOpen: false,
    drawerOpen: null,
    activeMenu: null,
    showLoginForm: false,
    closeTimer: null
  }),
  computed: {
    isLoggedIn() {
      return this.$store.state.isUserLoggedIn;
    },
    username() {
      const u = this.$store.state.user;
      if (u && u.nom) {
        return `${u.prenom || ''} ${u.nom}`.trim();
      }
      return '';
    },
    initials() {
      const words = this.username.split(' ').filter(Boolean);
      return words.length ? words.map(w => w[0]).join('').toUpperCase().slice(0, 2) : 'AS';
    },
    menuDesc() {
      return this.$t('home_page.nh_menu_desc');
    },
    devisParticulier() {
      const d = this.menuDesc;
      return [
        { href: '/devis/auto', icon: require('../assets/img/icones/menu/cars_quote.png'), tone: 'a', label: this.$t('home_page.bouton_devis[1]'), desc: d[0] },
        { href: '/devis/habitation', icon: require('../assets/img/icones/menu/house_quote.png'), tone: 'b', label: this.$t('home_page.bouton_devis[2]'), desc: d[1] },
        { href: '/devis/voyage', icon: require('../assets/img/icones/menu/travel_quote.png'), tone: 'a', label: this.$t('home_page.bouton_devis[3]'), desc: d[2] },
        { href: '/devis/sante', icon: require('../assets/img/icones/menu/health_quote.png'), tone: 'b', label: this.$t('home_page.bouton_devis[4]'), desc: d[3] },
        { href: '/devis/vie', icon: require('../assets/img/icones/menu/life_quote.png'), tone: 'a', label: this.$t('home_page.bouton_devis[5]'), desc: d[4] },
        { href: '/plus', icon: require('../assets/img/icones/menu/add_quote.png'), tone: 'b', label: this.$t('home_page.bouton_devis[6]'), desc: d[5] }
      ];
    },
    devisEntreprise() {
      const d = this.menuDesc;
      return [
        { href: '/flotte/entreprise', icon: require('../assets/img/icones/menu/cars_quote.png'), tone: 'a', label: this.$t('menu.Devis[7]'), desc: d[6] },
        { href: '/devis/mrp', icon: require('../assets/img/icones/menu/mrp_quote.png'), tone: 'b', label: 'MRP', desc: d[7] },
        { href: '/devis/trc', icon: require('../assets/img/icones/menu/trc_quote.png'), tone: 'a', label: 'TRC', desc: d[8] },
        { href: '/rcscolaire', icon: require('../assets/img/icones/rcscolaire.png'), tone: 'b', label: this.$t('menu.Devis[8]'), desc: d[9] }
      ];
    },
    simulationItems() {
      const d = this.menuDesc;
      return [
        { href: '/simulate/devis/auto', icon: require('../assets/img/icones/menu/cars_quote.png'), tone: 'a', label: this.$t('home_page.bouton_devis[1]'), desc: d[10] },
        { href: '/simulate/devis/voyage', icon: require('../assets/img/icones/menu/travel_quote.png'), tone: 'b', label: this.$t('home_page.bouton_devis[3]'), desc: d[11] }
      ];
    },
    assuranceItems() {
      const d = this.menuDesc;
      return [
        { href: '/assurance/Auto-Moto', icon: 'fas fa-car', tone: 'a', label: this.$t('menu.Assurances[1]'), desc: d[12] },
        { href: '/assurance/Habitation', icon: 'fas fa-home', tone: 'b', label: this.$t('menu.Assurances[2]'), desc: d[13] },
        { href: '/assurance/Voyage', icon: 'fas fa-plane', tone: 'a', label: this.$t('menu.Assurances[3]'), desc: d[14] },
        { href: '/assurance/Sante', icon: 'fas fa-heartbeat', tone: 'b', label: this.$t('menu.Assurances[4]'), desc: d[15] },
        { href: '/assurance/Vie', icon: 'fas fa-heart', tone: 'a', label: this.$t('menu.Assurances[5]'), desc: d[16] },
        { href: '/assurance/Assurplus', icon: 'fas fa-plus-circle', tone: 'b', label: this.$t('menu.Assurances[6]'), desc: d[17] },
        { href: '/assurance/sinistre', icon: 'fas fa-file-alt', tone: 'a', label: this.$t('menu.Assurances[7]'), desc: d[18] }
      ];
    }
  },
  methods: {
    openMenu(name) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.activeMenu = name;
    },
    closeMenu(name) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
      }
      this.closeTimer = setTimeout(() => {
        if (this.activeMenu === name) {
          this.activeMenu = null;
        }
      }, 150);
    },
    toggleDrawer(name) {
      this.drawerOpen = this.drawerOpen === name ? null : name;
    },
    updateLanguage() {
      const locale = String(this.$i18n.locale || 'FR')
        .trim()
        .toUpperCase()
        .startsWith('EN')
        ? 'EN'
        : 'FR';
      this.$i18n.locale = locale;
      sessionStorage.setItem('locale', locale);
    },
    goToSinistre() {
      this.menuOpen = false;
      if (!this.$store.state.isUserLoggedIn) {
        this.showLoginForm = true;
      } else {
        this.$router.push('/sinistre');
      }
    },
    StorageRemover() {
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setDevis', null);
      this.$store.dispatch('setDevisPayement', null);
      this.$store.dispatch('setDevisPayementDiffere', null);
      this.$store.dispatch('setuser_quote_count', null);
      this.$store.dispatch('setuser_contract_count', null);
      localStorage.removeItem('vuex');
      localStorage.setItem('isLogged', false);
    },
    logout() {
      Api()
        .get('user/logout/' + store.state.user._id)
        .then(() => this.StorageRemover())
        .catch(() => this.StorageRemover());
      this.$router.push('/');
      setTimeout(() => {
        window.location.reload();
      }, 600);
    },
    onScroll() {
      this.scrolled = window.scrollY > 24;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }
};
</script>

<style lang="less" scoped>
.nm {
  --c-orange: #ffa409;
  --c-orange-dark: #f57c00;
  --c-blue: #5B94BC;
  --c-blue-dark: #3d7ba6;
  --c-ink: #2b2b2b;
  --c-muted: #7a7e81;
  --c-cream: #FFFBF6;
  --c-orange-soft: #fff3df;
  --c-blue-soft: #eaf3f9;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: transparent;
  border-bottom: 1px solid transparent;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;

  &--scrolled {
    background: rgba(255, 255, 255, 0.9);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(14px);
    border-bottom-color: rgba(43, 43, 43, 0.06);
    box-shadow: 0 10px 34px rgba(43, 43, 43, 0.08);
  }

  &__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    height: 72px;
    padding: 0 32px;
    max-width: 1280px;
    margin: 0 auto;
  }

  &__logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    img {
      height: 44px;
      width: auto;
      object-fit: contain;
    }
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0 auto;
  }

  &__link {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 9px 14px;
    border: none;
    background: transparent;
    font-size: 15px;
    font-weight: 600;
    color: var(--c-ink);
    text-decoration: none;
    border-radius: 999px;
    cursor: pointer;
    transition: color 0.2s ease, background 0.2s ease;

    &:hover,
    &.is-active {
      color: var(--c-orange-dark);
      background: var(--c-orange-soft);
    }
  }

  &__caret {
    font-size: 11px;
    opacity: 0.65;
    transition: transform 0.25s ease;
  }

  .is-active &__caret {
    transform: rotate(180deg);
  }

  &__link-ico {
    font-size: 14px;
    opacity: 0.9;
  }

  &__link--highlight {
    background: linear-gradient(135deg, #ffb33d 0%, #ffa409 45%, #f57c00 100%);
    color: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 20px rgba(240, 136, 0, 0.32);

    .nm__caret {
      opacity: 0.85;
    }

    &:hover,
    &.is-active {
      color: #fff;
      background: linear-gradient(135deg, #ffa409 0%, #f57c00 100%);
      box-shadow: 0 12px 26px rgba(240, 136, 0, 0.42);
    }
  }

  &__link--blue {
    background: linear-gradient(135deg, #7db6d4 0%, #5B94BC 50%, #3d7ba6 100%);
    color: #fff;
    border-radius: 16px;
    box-shadow: 0 8px 20px rgba(61, 123, 166, 0.32);

    &:hover,
    &.is-active {
      color: #fff;
      background: linear-gradient(135deg, #5B94BC 0%, #3d7ba6 100%);
      box-shadow: 0 12px 26px rgba(61, 123, 166, 0.42);
    }
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  &__ctas {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__phone {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffb33d 0%, #ffa409 45%, #f57c00 100%);
    color: #fff;
    font-size: 16px;
    box-shadow: 0 8px 20px rgba(240, 136, 0, 0.28);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 26px rgba(240, 136, 0, 0.36);
    }
  }

  &__lang {
    appearance: none;
    border: 1.5px solid rgba(43, 43, 43, 0.16);
    background: #fff;
    border-radius: 999px;
    padding: 8px 28px 8px 16px;
    font-size: 13px;
    font-weight: 700;
    color: var(--c-ink);
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%232b2b2b' fill='none' stroke-width='1.6' stroke-linecap='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 13px center;
  }

  &__connect {
    border: 1.5px solid rgba(43, 43, 43, 0.18);
    background: #fff;
    color: var(--c-ink);
    font-size: 14px;
    font-weight: 700;
    padding: 9px 18px;
    border-radius: 999px;
    cursor: pointer;
    transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;

    &:hover {
      border-color: var(--c-orange);
      color: var(--c-orange-dark);
    }
  }

  &__cta {
    border: none;
    background: linear-gradient(135deg, #ffb33d 0%, #ffa409 45%, #f57c00 100%);
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 22px;
    border-radius: 999px;
    box-shadow: 0 10px 22px rgba(240, 136, 0, 0.3);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 14px 28px rgba(240, 136, 0, 0.38);
    }
  }

  &__burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 44px;
    height: 44px;
    padding: 10px;
    border: none;
    background: #fff3df;
    border-radius: 12px;
    cursor: pointer;

    span {
      display: block;
      height: 2.5px;
      border-radius: 3px;
      background: var(--c-orange-dark);
      transition: transform 0.25s ease, opacity 0.25s ease;
    }
  }

  &--open &__burger {
    span:nth-child(1) { transform: translateY(7.5px) rotate(45deg); }
    span:nth-child(2) { opacity: 0; }
    span:nth-child(3) { transform: translateY(-7.5px) rotate(-45deg); }
  }

  /* ===== Dropdown desktop ===== */
  &-dd {
    position: relative;

    &__panel {
      position: absolute;
      top: calc(100% + 12px);
      left: auto;
      right: 0;
      display: block;
      min-width: 320px;
      background: #fff;
      border: 1px solid rgba(43, 43, 43, 0.06);
      border-radius: 20px;
      box-shadow: 0 30px 70px rgba(43, 43, 43, 0.16);
      padding: 12px;
      z-index: 60;

      &::before {
        content: '';
        position: absolute;
        top: -12px;
        left: 0;
        right: 0;
        height: 12px;
      }

      &--single {
        min-width: 320px;
      }

      &--devis {
        min-width: 840px;
      }
    }

    &__title {
      margin: 2px 8px 8px;
      font-size: 12px;
      font-weight: 800;
      letter-spacing: 1.2px;
      text-transform: uppercase;
      color: var(--c-muted);
    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 6px;

      &--4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }
    }

    &__rule {
      height: 1px;
      background: rgba(43, 43, 43, 0.08);
      margin: 12px 2px;
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 13px;
      padding: 9px 12px;
      border-radius: 14px;
      text-decoration: none;
      transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

      &:hover {
        background: var(--c-orange-soft);
      }
    }

    &__chip {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 44px;
      height: 44px;
      border-radius: 14px;
      background: var(--c-blue-soft);
      color: var(--c-blue-dark);

      &--b {
        background: var(--c-orange-soft);
        color: var(--c-orange-dark);
      }

      img {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      i {
        font-size: 18px;
      }
    }

    &__meta {
      display: flex;
      flex-direction: column;
      gap: 1px;
      min-width: 0;

      strong {
        font-size: 14.5px;
        font-weight: 700;
        color: var(--c-ink);
      }

      small {
        font-size: 12.5px;
        font-weight: 500;
        color: var(--c-muted);
      }
    }
  }

  /* ===== Compte utilisateur ===== */
  &-user {
    position: relative;

    &__avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      border: 2px solid #ffd9a1;
      background: linear-gradient(135deg, #ffb33d, #f57c00);
      color: #fff;
      font-size: 14px;
      font-weight: 800;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__menu {
      position: absolute;
      top: calc(100% + 10px);
      right: 0;
      min-width: 210px;
      background: #fff;
      border: 1px solid rgba(43, 43, 43, 0.07);
      border-radius: 16px;
      box-shadow: 0 24px 60px rgba(43, 43, 43, 0.16);
      padding: 8px;
      z-index: 60;
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 11px 14px;
      border-radius: 10px;
      text-decoration: none;
      color: var(--c-ink);
      font-size: 14px;
      font-weight: 600;
      transition: background 0.2s ease;

      &:hover {
        background: #fff3e0;
      }

      i {
        width: 16px;
        color: var(--c-orange-dark);
        font-size: 14px;
      }
    }
  }

  /* ===== Drawer mobile ===== */
  &-drawer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 86vw;
    max-width: 360px;
    background: var(--c-cream);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    box-shadow: -20px 0 60px rgba(43, 43, 43, 0.22);

    &__head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 20px;
      border-bottom: 1px solid rgba(255, 164, 9, 0.2);
    }

    &__close {
      width: 40px;
      height: 40px;
      border: none;
      border-radius: 12px;
      background: #fff3df;
      color: var(--c-orange-dark);
      font-size: 18px;
      cursor: pointer;
    }

    &__body {
      flex: 1;
      overflow-y: auto;
      padding: 12px 16px;
    }

    &__foot {
      padding: 14px 16px 22px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-top: 1px solid rgba(255, 164, 9, 0.2);
    }

    &__cta {
      display: block;
      text-align: center;
      border: none;
      text-decoration: none;
      background: linear-gradient(135deg, #ffb33d 0%, #ffa409 45%, #f57c00 100%);
      color: #fff;
      font-size: 15px;
      font-weight: 700;
      padding: 14px;
      border-radius: 14px;
      box-shadow: 0 10px 24px rgba(240, 136, 0, 0.3);
      cursor: pointer;

      &--ghost {
        background: transparent;
        color: var(--c-orange-dark);
        border: 1.5px solid rgba(255, 164, 9, 0.55);
        box-shadow: none;
      }
    }
  }

  /* ===== Accordion mobile ===== */
  &-acc {
    border-bottom: 1px solid rgba(43, 43, 43, 0.08);

    &__toggle,
    &__link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 16px 6px;
      border: none;
      background: transparent;
      font-size: 16px;
      font-weight: 700;
      color: var(--c-ink);
      text-decoration: none;
      cursor: pointer;

      > i {
        font-size: 13px;
        transition: transform 0.25s ease;
      }
    }

    &__ttl {
      display: inline-flex;
      align-items: center;
      gap: 10px;

      i {
        font-size: 15px;
        color: inherit;
      }
    }

    &__toggle--highlight {
      color: var(--c-orange-dark);
      font-weight: 800;
    }

    &__toggle--blue {
      color: var(--c-blue-dark);
    }

    &__link {
      border-bottom: 1px solid rgba(43, 43, 43, 0.08);
    }

    &.is-open .nm-acc__toggle > i {
      transform: rotate(180deg);
    }

    &__panel {
      display: none;
      padding: 2px 0 14px;
    }

    &.is-open &__panel {
      display: block;
    }

    &__group {
      margin: 8px 8px 4px;
      font-size: 12px;
      font-weight: 800;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: var(--c-muted);
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px;
      border-radius: 14px;
      text-decoration: none;
      transition: background 0.2s ease;

      &:hover {
        background: var(--c-orange-soft);
      }
    }

    &__chip {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 12px;
      background: var(--c-blue-soft);
      color: var(--c-blue-dark);

      &--b {
        background: var(--c-orange-soft);
        color: var(--c-orange-dark);
      }

      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }

      i {
        font-size: 16px;
      }
    }

    &__meta {
      display: flex;
      flex-direction: column;
      gap: 1px;

      strong {
        font-size: 15px;
        font-weight: 700;
        color: var(--c-ink);
      }

      small {
        font-size: 12.5px;
        font-weight: 500;
        color: var(--c-muted);
      }
    }
  }
}

/* ===== Transitions ===== */
.nm-fade-enter-active,
.nm-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.nm-fade-enter,
.nm-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.nm-drawer-enter-active,
.nm-drawer-leave-active {
  transition: transform 0.32s cubic-bezier(0.22, 0.61, 0.36, 1);
}
.nm-drawer-enter,
.nm-drawer-leave-to {
  transform: translateX(100%);
}

@media (max-width: 991px) {
  .nm {
    &__bar {
      height: 64px;
      padding: 0 18px;
    }

    &__logo img {
      height: 38px;
    }

    &__nav,
    &__account {
      display: none;
    }

    &__lang {
      display: none;
    }

    &__phone {
      width: 40px;
      height: 40px;
      font-size: 15px;
    }

    &__burger {
      display: flex;
    }
  }
}
</style>
